import { ShowerHead, Warehouse, Waves, Sun } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import masterplan3D from "@/assets/masterplan-3d-aerial.jpg";
import villaHero from "@/assets/villa-hero-totem.png";
import villaFloorplan from "@/assets/villa-floorplan-3d.webp";
import masterplanTopdown from "@/assets/masterplan-topdown-totem.jpg";
import iconPoolSunset from "@/assets/icon-pool-sunset.png";
import iconSolar from "@/assets/icon-solar.png";
import iconWindowUV from "@/assets/icon-window-uv.png";
import iconChanod from "@/assets/icon-chanod.png";
import "@/styles/totem-print.css";

const Totem = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <button className="totem-print-button" onClick={handlePrint}>
        🖨️ Print Totem
      </button>
      <div 
        className="totem-container bg-background flex flex-col items-center relative"
        style={{ 
          width: '60cm', 
          height: '120cm',
          padding: '3cm 4cm',
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          boxSizing: 'border-box',
        }}
      >
      {/* Logo Section */}
      <div className="text-center flex flex-col items-center" style={{ marginBottom: '2cm' }}>
        <h1 
          className="font-serif text-foreground leading-none"
          style={{ fontSize: '3.5cm', letterSpacing: '0.5cm', fontWeight: 300, fontSynthesis: 'none', lineHeight: 1, marginBottom: '0.3cm' }}
        >
          SIAM HORIZON
        </h1>
        <div className="flex items-center justify-center">
          <div 
            style={{ 
              width: '6cm', 
              height: '2px',
              background: 'linear-gradient(to left, hsl(var(--foreground)) 75%, transparent 100%)'
            }}
          />
          <div 
            style={{ 
              width: '6cm', 
              height: '2px',
              background: 'linear-gradient(to right, hsl(var(--foreground)) 75%, transparent 100%)'
            }}
          />
        </div>
        <p 
          className="font-serif text-muted-foreground leading-none"
          style={{ fontSize: '2.2cm', letterSpacing: '0.3cm', fontWeight: 300, fontSynthesis: 'none', lineHeight: 1, marginTop: '0.3cm' }}
        >
          HUA HIN
        </p>
        <p 
          className="text-accent uppercase font-light"
          style={{ fontSize: '1cm', letterSpacing: '0.3cm', marginTop: '0.8cm' }}
        >
          Soi Chonprathan 44
        </p>
      </div>

      {/* Decorative Line */}
      <div className="bg-accent" style={{ width: '6cm', height: '3px', marginBottom: '1.5cm' }} />

      {/* Tagline */}
      <div className="text-center" style={{ marginBottom: '1.5cm' }}>
        <h1 
          className="text-foreground font-light"
          style={{ fontSize: '2.2cm', letterSpacing: '0.15cm' }}
        >
          Tropical Pool Villas
        </h1>
        <h1 
          className="text-foreground font-light"
          style={{ fontSize: '2.2cm', letterSpacing: '0.15cm' }}
        >
          on the Thai Riviera
        </h1>
      </div>

      {/* Hero Villa Image */}
      <div style={{ width: '48cm', marginBottom: '1.5cm' }}>
        <img 
          src={villaHero} 
          alt="Siam Horizon Villa - Modern design with pool and tropical garden" 
          className="w-full h-auto shadow-xl"
          style={{ border: '6px solid white' }}
        />
      </div>

      {/* Project Description */}
      <div className="text-center" style={{ maxWidth: '45cm', marginBottom: '1.5cm' }}>
        {/* Stats Grid */}
        <div className="grid grid-cols-5" style={{ gap: '1.2cm', margin: '1.5cm 0' }}>
          <div className="text-center">
            <p className="font-serif text-accent leading-none" style={{ fontSize: '2.5cm', marginBottom: '0.5cm', lineHeight: 1 }}>257</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>sqm built space</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-accent leading-none" style={{ fontSize: '2.5cm', marginBottom: '0.5cm', lineHeight: 1 }}>136</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>sqm indoor living</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-accent leading-none" style={{ fontSize: '2.5cm', marginBottom: '0.5cm', lineHeight: 1 }}>3</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>Bedrooms<br />En-Suite</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-accent leading-none" style={{ fontSize: '2.5cm', marginBottom: '0.5cm', lineHeight: 1 }}>3</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>Bathrooms</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-accent leading-none" style={{ fontSize: '1.8cm', marginBottom: '0.5cm', lineHeight: 1 }}>🌴</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>Tropical Garden</p>
            <p className="text-muted-foreground uppercase" style={{ fontSize: '0.65cm', letterSpacing: '0.12cm', lineHeight: 1.2 }}>350 - 800 sq.m. & more</p>
            
          </div>
        </div>

        {/* Price Tag */}
        <div 
          className="bg-accent text-accent-foreground inline-block text-center"
          style={{ padding: '0.8cm 2cm', marginTop: '0.5cm' }}
        >
          <p className="uppercase" style={{ fontSize: '0.85cm', letterSpacing: '0.15cm' }}>Invest in comfort and convenience, no compromises.</p>
          <div className="flex items-center justify-center" style={{ margin: '0.6cm 0' }}>
            <div 
              style={{ 
                width: '6cm', 
                height: '2px',
                background: 'linear-gradient(to left, white 75%, transparent 100%)'
              }}
            />
            <div 
              style={{ 
                width: '6cm', 
                height: '2px',
                background: 'linear-gradient(to right, white 75%, transparent 100%)'
              }}
            />
          </div>
          <p className="uppercase" style={{ fontSize: '0.85cm', letterSpacing: '0.15cm' }}>LIMITED COLLECTION</p>
        </div>

        {/* Features List - 5 boxes with Freehold centered */}
        <div className="flex justify-center items-center" style={{ gap: '0.8cm', marginTop: '1.5cm' }}>
          <div className="flex flex-col items-center justify-center relative" style={{ padding: '0.5cm 0.4cm', width: '7cm', height: '5cm', border: '3px solid hsl(38, 70%, 55%)', borderImage: 'linear-gradient(135deg, hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%)) 1', background: 'linear-gradient(135deg, hsl(45, 40%, 97%), hsl(38, 30%, 94%))' }}>
            <div style={{ position: 'absolute', top: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', top: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div className="flex flex-col items-center justify-center" style={{ marginBottom: '0.4cm', gap: '0.1cm' }}>
              <Sun className="text-accent" style={{ width: '1.2cm', height: '1.2cm' }} strokeWidth={1.2} />
              <Waves className="text-accent" style={{ width: '1.8cm', height: '0.8cm' }} strokeWidth={1.2} />
            </div>
            <p className="text-foreground" style={{ fontSize: '0.55cm', lineHeight: 1.3, fontWeight: 500 }}>Private<br />Saltwater Pool</p>
          </div>
          <div className="flex flex-col items-center justify-center relative" style={{ padding: '0.5cm 0.4cm', width: '7cm', height: '5cm', border: '3px solid hsl(38, 70%, 55%)', borderImage: 'linear-gradient(135deg, hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%)) 1', background: 'linear-gradient(135deg, hsl(45, 40%, 97%), hsl(38, 30%, 94%))' }}>
            <div style={{ position: 'absolute', top: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', top: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <img src={iconSolar} alt="Solar" style={{ width: '2cm', height: '2cm', objectFit: 'contain', marginBottom: '0.4cm' }} />
            <p className="text-foreground" style={{ fontSize: '0.55cm', lineHeight: 1.3, fontWeight: 500 }}>Solar Panels<br /><span style={{ fontSize: '0.5cm' }}>10 kW &amp; Battery</span></p>
          </div>
          <div 
            className="flex flex-col items-center relative"
            style={{ 
              padding: '1.2cm 1.2cm', 
              width: '13cm',
              height: '7cm',
              justifyContent: 'center',
              border: '4px solid hsl(38, 70%, 55%)',
              borderImage: 'linear-gradient(135deg, hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%)) 1',
              boxShadow: 'inset 0 0 0 3px hsl(38, 70%, 55%, 0.15), 0 4px 20px hsl(38, 70%, 45%, 0.15)',
              background: 'linear-gradient(135deg, hsl(45, 40%, 97%), hsl(38, 30%, 94%))',
            }}
          >
            {/* Corner ornaments */}
            <div style={{ position: 'absolute', top: '0.2cm', left: '0.2cm', width: '1cm', height: '1cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', top: '0.2cm', right: '0.2cm', width: '1cm', height: '1cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.2cm', left: '0.2cm', width: '1cm', height: '1cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.2cm', right: '0.2cm', width: '1cm', height: '1cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <img src={iconChanod} alt="Chanod" style={{ width: '3cm', height: '3cm', objectFit: 'contain', marginBottom: '0.5cm' }} />
            <p className="text-foreground" style={{ fontSize: '0.75cm', lineHeight: 1.3, fontWeight: 500 }}>Freehold or Leasehold</p>
            <p className="text-muted-foreground" style={{ fontSize: '0.55cm', lineHeight: 1.3, fontStyle: 'italic' }}>(depending on your legal status)</p>
          </div>
          <div className="flex flex-col items-center justify-center relative" style={{ padding: '0.5cm 0.4cm', width: '7cm', height: '5cm', border: '3px solid hsl(38, 70%, 55%)', borderImage: 'linear-gradient(135deg, hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%)) 1', background: 'linear-gradient(135deg, hsl(45, 40%, 97%), hsl(38, 30%, 94%))' }}>
            <div style={{ position: 'absolute', top: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', top: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <img src={iconWindowUV} alt="Windows" style={{ width: '2cm', height: '2cm', objectFit: 'contain', marginBottom: '0.4cm' }} />
            <p className="text-foreground" style={{ fontSize: '0.55cm', lineHeight: 1.3, fontWeight: 500 }}>Double Glazed<br />Aluminium Windows</p>
          </div>
          <div className="flex flex-col items-center justify-center relative" style={{ padding: '0.5cm 0.4cm', width: '7cm', height: '5cm', border: '3px solid hsl(38, 70%, 55%)', borderImage: 'linear-gradient(135deg, hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%), hsl(38, 70%, 45%), hsl(45, 80%, 65%)) 1', background: 'linear-gradient(135deg, hsl(45, 40%, 97%), hsl(38, 30%, 94%))' }}>
            <div style={{ position: 'absolute', top: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', top: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderTop: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', left: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderLeft: '2px solid hsl(38, 70%, 55%)' }} />
            <div style={{ position: 'absolute', bottom: '0.15cm', right: '0.15cm', width: '0.6cm', height: '0.6cm', borderBottom: '2px solid hsl(38, 70%, 55%)', borderRight: '2px solid hsl(38, 70%, 55%)' }} />
            <div className="flex items-center justify-center" style={{ width: '2cm', height: '2cm', marginBottom: '0.4cm', gap: '0.2cm' }}>
              <ShowerHead className="text-accent" style={{ width: '1.5cm', height: '1.5cm' }} strokeWidth={1.2} />
              <Warehouse className="text-accent" style={{ width: '1.5cm', height: '1.5cm' }} strokeWidth={1.2} />
            </div>
            <p className="text-foreground" style={{ fontSize: '0.5cm', lineHeight: 1.3, fontWeight: 500 }}>Utility Storages &<br />Guest Amenities</p>
          </div>
        </div>
      </div>

      {/* Decorative Line */}
      <div className="bg-accent" style={{ width: '6cm', height: '3px', marginBottom: '1cm' }} />

      {/* Villa Floor Plan (moved above aerial) */}
      <div style={{ width: '48cm', marginBottom: '1cm' }}>
        <img 
          src={villaFloorplan} 
          alt="Siam Horizon Villa Floor Plan - 3 bedrooms layout" 
          className="w-full h-auto shadow-xl"
          style={{ border: '6px solid white' }}
        />
      </div>

      {/* Masterplan 3D Aerial */}
      <div style={{ width: '48cm', marginBottom: '1cm' }}>
        <img 
          src={masterplan3D} 
          alt="Siam Horizon 3D Aerial View - 10 villas with sea view" 
          className="w-full h-auto shadow-xl"
          style={{ border: '6px solid white' }}
        />
      </div>

      {/* Top-down Masterplan */}
      <div style={{ width: '48cm', marginBottom: '1cm' }}>
        <img 
          src={masterplanTopdown} 
          alt="Siam Horizon Top-down Masterplan - Plot layout overview" 
          className="w-full h-auto shadow-xl"
          style={{ border: '6px solid white' }}
        />
      </div>

      {/* Legend */}
      <div className="flex justify-center" style={{ gap: '2cm', marginBottom: '1.5cm' }}>
        <div className="flex items-center" style={{ gap: '0.4cm' }}>
          <div className="bg-[hsl(120,50%,50%)] rounded" style={{ width: '0.8cm', height: '0.8cm' }} />
          <span className="text-muted-foreground" style={{ fontSize: '0.8cm' }}>Available</span>
        </div>
        <div className="flex items-center" style={{ gap: '0.4cm' }}>
          <div className="bg-[hsl(36,100%,49%)] rounded" style={{ width: '0.8cm', height: '0.8cm' }} />
          <span className="text-muted-foreground" style={{ fontSize: '0.8cm' }}>Reserved</span>
        </div>
        <div className="flex items-center" style={{ gap: '0.4cm' }}>
          <div className="bg-[hsl(4,90%,58%)] rounded" style={{ width: '0.8cm', height: '0.8cm' }} />
          <span className="text-muted-foreground" style={{ fontSize: '0.8cm' }}>Sold</span>
        </div>
      </div>

      {/* Contact Section */}
      <div className="text-center mt-auto">
        <div className="bg-accent mx-auto" style={{ width: '6cm', height: '3px', marginBottom: '1.5cm' }} />
        
        {/* QR Code */}
        <div style={{ marginBottom: '1.2cm' }}>
          <div className="bg-card inline-block shadow-lg rounded-lg" style={{ padding: '0.6cm' }}>
            <QRCodeSVG 
              value="https://siamhorizon.com" 
              size={150}
              bgColor="#FFFFFF"
              fgColor="hsl(25, 18%, 20%)"
              level="H"
              includeMargin={false}
            />
          </div>
          <p className="text-muted-foreground" style={{ fontSize: '0.7cm', marginTop: '0.6cm', letterSpacing: '0.1cm' }}>
            Scan to visit our website
          </p>
        </div>
        
        <p className="font-serif text-foreground" style={{ fontSize: '1.5cm', marginBottom: '1cm', letterSpacing: '0.3cm', fontWeight: 300, fontSynthesis: 'none' }}>CONTACT</p>
        <p className="text-accent" style={{ fontSize: '1cm', marginBottom: '0.8cm' }}>+66 63 491 4425</p>
        <p className="text-muted-foreground" style={{ fontSize: '0.9cm', marginBottom: '0.8cm' }}>contact@siamhorizon.com</p>
        <p className="text-accent" style={{ fontSize: '1cm', letterSpacing: '0.1cm' }}>www.siamhorizon.com</p>
      </div>

      {/* Disclaimer */}
      <p 
        className="text-muted-foreground"
        style={{ 
          fontSize: '0.45cm', 
          maxWidth: '40cm', 
          lineHeight: 1.4,
          fontStyle: 'italic',
          marginTop: '1.5cm',
          opacity: 0.5,
          textAlign: 'center'
        }}
      >
        The content of this document is presented for general information purposes and does not create any contractual obligations.
        <br />
        Legal commitments arise exclusively from duly executed written agreements between the company and the purchaser.
      </p>
    </div>
    </>
  );
};

export default Totem;
